import { NgModule } from '@angular/core';
import { OfflineToolbarComponent } from '@app/shared/offline-toolbar/offline-toolbar.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [OfflineToolbarComponent],
  imports: [CommonModule, MatButtonModule, TranslateModule],
  exports: [OfflineToolbarComponent],
})
export class OfflineToolbarModule {}
